export default "__VITE_ASSET__CQutzJnp__"